function cov_2aetp3djnq() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/HomeChat.tsx";
  var hash = "19ca403d45652ecc0c42cdd2e2c2703ec74245c1";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/HomeChat.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 49
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "19ca403d45652ecc0c42cdd2e2c2703ec74245c1"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2aetp3djnq = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2aetp3djnq();
var Icon = (cov_2aetp3djnq().s[0]++, {
  name: 'home-chat',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 18H19C20.6569 18 22 16.6569 22 15V2H5C3.34315 2 2 3.34315 2 5V18H8L11.75 22L16 18ZM11.8606 18.4627L15.0086 15.5H19C19.2761 15.5 19.5 15.2761 19.5 15V4.5H5C4.72386 4.5 4.5 4.72386 4.5 5V15.5H9.08308L11.8606 18.4627Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 5.79769L16.25 8.63102V14.05H7.75V8.63102L12 5.79769ZM10.25 9.96898V11.55H13.75V9.96898L12 8.80231L10.25 9.96898Z\" fill=\"currentColor\"/>"
});
export default Icon;